module.exports = __webpack_public_path__ + "images/harmonie-377fc82cfb8d5cd5024a8bcd5ed13344.jpg";